export default {
   getLang: (state) => {
      return state.language;
   },
   
   arb: (state) => {
      if (state.language == 'ar') return true;
      else return false; 
   }
}